import { render } from "./SiteCredits.vue?vue&type=template&id=1c5b65ae"
import script from "./SiteCredits.vue?vue&type=script&lang=js"
export * from "./SiteCredits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__